import colors, { options } from '@classify/design-tokens/colors';
import merge from 'lodash/merge';
import { alpha } from '../styles';

const MUIRequiredPalette = {
  primary: {
    // MUI
    main: colors.brand.primary,
    light: colors.brand.primary,
    dark: colors.brand.primary,
  },
  secondary: {
    // MUI
    main: options.midGrey,
    light: options.midGrey,
    dark: options.midGrey,
  },
  error: {
    // MUI
    main: colors.notification.error.main,
    light: colors.notification.error.main,
    dark: colors.notification.error.main,
  },
};

const deprecatedPalette = {
  brand: {
    main: colors.brand.primary, // deprecated
    highlightPrimary: '#00f8f6', // deprecated
    highlightSecondary: '#00eda2', // deprecated
  },
  line: colors.layout.line.divider, // deprecated replaced by palette.layout.line.divider
  divider: colors.layout.line.divider, // deprecated
  stroke: '#eeeeee', // deprecated
  background: {
    // deprecated
    default: '#fafafa', // deprecated
    primary: options.white, // deprecated
    secondary: options.black, // deprecated
    alternative: '#f5f5f5', // deprecated replaced by layout.background.alternative
    neutral: '#f4f4f4', // deprecated
    brand: alpha(options.royalPurple, 0.08), // deprecated
    tableHead: '#003668', // deprecated
    information: options.lochmara, // deprecated
    warning: options.orange, // deprecated
    error: options.guardsmanRed, // deprecated
    question: '#616161', // deprecated
    funding: '#ffe7ea', // deprecated
    cpf: '#164194', // deprecated
    projectHeader: '#f5f5f5', // deprecated
    dashboard: '#fafafa', // deprecated
    objectList: '#fafafa', // deprecated
    gradient: {
      business: `linear-gradient(165deg, ${options.royalPurple} -16%, #003668 75%)`, // deprecated
      funding: `linear-gradient(180deg, #ffe7ea 0%, ${alpha(options.white, 0)} 100%), #ffe7ea`, // deprecated
    },
    marketing: {
      // deprecated
      secondary: '#F6EF59', // deprecated
    },
  },
  text: {
    primary: colors.text.onMain, // deprecated
    hint: colors.text.onMain, // deprecated
    caption: colors.text.onMain, // deprecated
    secondary: '#616161', // deprecated
    inactive: '#616161', // deprecated
    link: options.royalPurple, // deprecated
    linkOnContrasted: colors.text.onMain, // deprecated
  },
  calendar: {
    mentorshipSession: options.lochmara, // deprecated
    presentation: options.aquaDeep, // deprecated
    weekdays: '#616161', // deprecated
    today: '#616161', // deprecated
    background: options.white, // deprecated
    text: colors.text.onMain, // deprecated
    textAlternative: options.white, // deprecated
    interactiveHeader: '#f5f5f5', // deprecated
    selectedDate: options.royalPurple, // deprecated
    interactiveDay: alpha(options.royalPurple, 0.16), // deprecated
  },
  learningCategories: {
    development: options.blueLagoon, // deprecated
    network: options.lochmara, // deprecated
    marketing: options.blueRibbon, // deprecated
    data: options.aquaDeep, // deprecated
    projectManagement: options.daisyBush, // deprecated
    hr: options.navyBlue, // deprecated
    careerCoaching: options.amethyst, // deprecated
    design: options.amaranth, // deprecated
    pedagogy: options.pomegranate, // deprecated
    entrepreneurship: options.darkBlue, // deprecated
    finance: '#008577', // deprecated
    softSkills: '#795548', // deprecated
    other: options.royalPurple, // deprecated
  },
  analytics: {
    primary: options.navyBlue, // deprecated
    secondary: alpha(options.amethyst, 0.64), // deprecated
  },
  roles: {
    admin: options.blueLagoon, // deprecated
    manager: options.navyBlue, // deprecated
    teamManager: options.amethyst, // deprecated
    mentor: options.lochmara, // deprecated
    recruiter: options.darkBlue, // deprecated
  },
  status: {
    // deprecated (Replaced by notification)
    notStarted: colors.notification.neutral.main, // deprecated
    inactive: colors.notification.neutral.main, // deprecated
    notCompleted: '#d2d2d2', // deprecated
    success: colors.notification.valid.main, // deprecated
    awaiting: colors.notification.info.main, // deprecated
    info: colors.notification.info.main, // deprecated
    inProgress: colors.notification.valid.main, // deprecated
    retry: options.orange, // deprecated
    warning: colors.notification.warning.main, // deprecated
    fail: colors.notification.error.main, // deprecated
    danger: colors.notification.danger.main, // deprecated
    neutral: options.gainsboro, // deprecated
  },
};

const palette = {
  ...merge(deprecatedPalette, colors),
  ...MUIRequiredPalette,
};

export default palette;
